import { AxiosRequestHeaders } from 'axios';
import { ClientResponse } from '../../../model/types/ClientResponse';
import { indexerAxiosInstance } from '../../configuration/axiosConfig';

interface Props {
  nazov: string;
  iri: string;
}

interface VyhladavanieItem {
  iri: string;
  popis: string;
  typ: string;
}

export async function getSearchData(
  value: string,
  requestPath: string,
  path: string,
  options?: { headers?: object },
): Promise<ClientResponse<Props[]>> {
  const {
    data,
    status: responseCode,
  } = await indexerAxiosInstance.get<VyhladavanieItem[]>(requestPath, {
    headers: options?.headers as AxiosRequestHeaders,
    params: {
      dopyt: value,
      rows: 50,
    },
  });

  const mappedData = data
    .filter((item) => item.typ !== 'nadpis.predpisZbierky')
    .map((item) => ({
      iri: path + item.iri,
      nazov: item.popis,
    }));

  return {
    data: mappedData,
    responseCode,
  };
}
